import { render, staticRenderFns } from "./ClinicTable.vue?vue&type=template&id=03677162"
import script from "./ClinicTable.vue?vue&type=script&lang=js"
export * from "./ClinicTable.vue?vue&type=script&lang=js"
import style0 from "./ClinicTable.vue?vue&type=style&index=0&id=03677162&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports